import React from 'react';

import Directory from '../../components/directory/directory.component';

 import './homepage.styles.scss';

   
 
 const HomePage = () => (
     
         <div className='HomePage'>
            <Directory />
         </div>
     ); 
 
 
 export default HomePage;
 